import classnames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import Button from '../Button/Button'
import Checkbox from '../Checkbox/Checkbox'
import CircularLoaderV2 from '../CircularLoaderV2/CircularLoaderV2'
import Dropdown from '../DropDown/Dropdown'
import Icon from '../Icon2/Icon'
import Search from '../Search/Search'

import {
  MAX_FREEZE_COUNT,
  compareColumn,
  filterColumnData,
  getHeaderValue,
  getTableCount,
  move,
  reorderList
} from './util'

const InfoComponent = () => {
  return (
    <div
      onClick={(event) => {
        event.stopPropagation()
      }}
      className="TablePanel__info_container">
      <div className="mr-10">
        <Icon icon="Warning" size="small" />
      </div>
      <div className="TablePanel__info_text">At least two columns must be visible</div>
    </div>
  )
}

const Selector = ({ column, isLock = false, allVisibleColumn, canFreezeColumn, freezedUnfreezeColumn }) => {
  const toggleHiddenProps = { ...column.getToggleHiddenProps() }
  return (
    <div className="selector">
      <Checkbox
        text={typeof column.Header === 'function' ? <column.Header /> : column.Header}
        {...toggleHiddenProps}
        disabled={column.default || isLock || (allVisibleColumn.length <= 2 && allVisibleColumn.includes(column.id))}
        testId={'tabel-column-selector-checkbox'}
        aria-label={`${getHeaderValue(column.Header)} column ${toggleHiddenProps.checked ? 'visible' : 'hidden'}`}
      />
      {canFreezeColumn && (
        <span
          aria-label={`${isLock ? 'unfreeze' : 'freeze'} ${getHeaderValue(column.Header)} column`}
          data-test-id={'tabel-column-freeze-unfreeze-icon'}
          className={`selector-icon ${column.isVisible ? '' : 'disabled'} ${!isLock ? 'unfreeze' : 'freeze'}`}
          onClick={() => freezedUnfreezeColumn(column)}
          tabIndex={toggleHiddenProps.checked ? 0 : -1}>
          <Icon
            withTooltip={true}
            tooltipContent={isLock ? 'Unfreeze' : 'Freeze'}
            tooltipPosition="top"
            version="v2"
            size="medium"
            icon={!isLock ? 'Freezed' : 'Unfreezed'}
          />
        </span>
      )}
    </div>
  )
}

const TableSetting = ({ isDisabled, isOpenAddColumn, setIsOpenAddColumn, primaryDropdownList }) => {
  const [actionSelected, setActionSelected] = useState('')
  const [showDropdown, setShowDropdown] = useState(false)
  const [isCursorInside, setIsCursorInside] = useState(false)

  let tablePanelValueRef: any = useRef({})
  tablePanelValueRef.current.isCursorInside = isCursorInside
  tablePanelValueRef.current.showDropdown = showDropdown

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener('click', handleClickOutside,true)
      document.addEventListener('closeTableSettingDropdown', closeDropdown)
      document.addEventListener('keyup', registerKeybindings, false)

      return () => {
        document.removeEventListener('click', handleClickOutside,true)
        document.removeEventListener('closeTableSettingDropdown', closeDropdown)
        document.removeEventListener('keyup', registerKeybindings, false)
      }
    }
  }, [showDropdown])

  const closeDropdown = () => {
    setShowDropdown(false)
    setActionSelected('')
  }
  useEffect(() => {
    if (isOpenAddColumn) {
      setIsOpenAddColumn(false)
      setShowDropdown(true)
      setActionSelected('manage_columns')
    }
  }, [isOpenAddColumn])

  const handleClickOutside = () => {
    if (tablePanelValueRef.current.showDropdown && !tablePanelValueRef.current.isCursorInside) {
      setShowDropdown(false)
      setActionSelected('')
    }
  }

  const registerKeybindings = (e) => {
    if (e.key === 'Escape') {
      closeDropdown()
    }
  }

  return (
    <div
      className={`${isDisabled ? 'settings-wrapper-container-disabled' : ''}`}
      onMouseEnter={() => {
        setIsCursorInside(true)
      }}
      onMouseLeave={() => {
        setIsCursorInside(false)
      }}>
      {primaryDropdownList.length > 0 && (
        <Button
          aria-expanded={showDropdown ? 'true' : 'false'}
          aria-label="Table Settings"
          role="menu"
          className={`settings-wrapper`}
          disabled={isDisabled}
          testId="cs-table-settings-wrapper"
          onClick={(e) => {
            if (e.type === 'click' && e.pageX !== 0 && e.pageY !== 0) {
              e.preventDefault()
              // e.stopPropagation()
              setShowDropdown(!showDropdown)
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setShowDropdown(!showDropdown)
              return
            }
            if (e.key === 'Escape' && showDropdown) {
              closeDropdown()
            }
          }}
          size="regular"
          buttonType="tertiary"
          onlyIcon={true}
          icon={'v2-Setting'}
          version="v2"
          onlyIconHoverColor="secondary"
          onlyIconActive={showDropdown}
          iconProps={{
            withTooltip: true,
            tooltipContent: 'Table Settings',
            tooltipPosition: 'left'
          }}
        />
      )}
      {showDropdown && (
        <div className="TablePanel__actions_list">
          <ul role="menu">
            {primaryDropdownList.map((option, index) => {
              return (
                <li
                  id="tableSettingBtn"
                  className={classnames('TablePanel__actions_list_item', option.value === actionSelected && 'selected')}
                  data-test-id={`table-panel-action-list-item_${option.value}`}
                  key={option.value}
                  onMouseEnter={(e) => setActionSelected(option.value)}
                  tabIndex={0}
                  aria-label={option.label}
                  role="menuitem"
                  onKeyDown={(e) => {
                    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                      setActionSelected(option.value)
                      setTimeout(() => {
                        document.getElementById('cs-dropdown-list-comfortView')?.focus()
                      })
                      return
                    }
                  }}>
                  <div className="dropdown-primary">
                    <span className="dropdown-primary-item">
                      <Icon
                        version="v2"
                        icon={option.icon}
                        size="medium"
                      // active={getActiveStateIcon(actionSelected, option.value)}
                      // activeIcon={option.activeIcon}
                      // className="dropdown-list"
                      />{' '}
                      {option.label}
                    </span>
                    <span className="Right-icon-wrapper">
                      <Icon
                        version="v2"
                        // active={getActiveStateIcon(actionSelected, option.value)}
                        icon="Right"
                        size="medium"
                      />
                    </span>
                  </div>
                  {option.value === actionSelected && (
                    <div className={`TablePanel__actions__subitems flex-v-center `}>
                      <Dropdown
                        version="v2"
                        type="click"
                        closeAfterSelect={false}
                        dropDownPosition="bottom"
                        className={`flex-v-center ${option.className}`}
                        isOpen={true}
                        list={option.list}
                        lists={option.lists}
                        dragDropProps={option.dragDropProps}
                        isMultiCheck={option.isMultiCheck}
                        infoComponent={option.infoComponent}
                        canCloseOnClickOutside={false}
                        testId={`table-panel-action-list-subitem`}
                      />
                    </div>
                  )}
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}

const TablePanel = (props) => {
  const {
    columnSelector,
    allColumns,
    totalCounts,
    name,
    viewSelector,
    dropDownList,
    // viewBy,
    loading,
    searchPlaceholder,
    onChangeSearch,
    onRefresh,
    searchValue,
    canSearch,
    canRefresh,
    staticRowCount,
    onToggleColumnSelector,
    withExportCta,
    setTableColumnOrder,
    canOrderColumn,
    freezedUnfreezeColumn,
    canFreezeColumn,
    listData,
    setListData,
    setDragListData,
    setIsOpenAddColumn,
    isOpenAddColumn,
    hasFreezedColumn,
    showTotalCount,
    countExceedPompt,
    v2Features
  } = props

  const allVisibleColumn = allColumns
    .filter((column) => column.isVisible && column.addToColumnSelector)
    .map((column) => column.id)

  let totalString = getTableCount({ totalCounts, name, staticRowCount, countExceedPompt })

  const onChangeColumnSelector = (allColumnsData) => {
    let [freezed = [], unfreezed = []] = listData
    freezed = compareColumn(allColumnsData, freezed)
    unfreezed = compareColumn(allColumnsData, unfreezed)
    setListData([freezed, unfreezed])
    if (onToggleColumnSelector) {
      const columnSelectorData = filterColumnData(allColumnsData)
      onToggleColumnSelector(columnSelectorData)
    }
  }
  const getSettingsDropdownList = (viewSelector, columnSelector, canFreezeColumn) => {
    let lists = []
    if (props.dropdownCustomOptions && props.dropdownCustomOptions.length > 0) {
      lists = [...lists, ...props.dropdownCustomOptions]
    }
    if (columnSelector) {
      lists.push({
        label: 'Manage columns',
        value: 'manage_columns',
        icon: 'ManageColumn',
        activeIcon: 'ManageColumn',
        list: canFreezeColumn ? [] : list,
        lists: canFreezeColumn ? getDropdownList() : [],
        dragDropProps: {
          canDragAndDrop: canOrderColumn,
          onDragEnd: onDragEnd,
          labels: canFreezeColumn ? ['Frozen Columns', 'Unfrozen Columns'] : ''
        },
        isMultiCheck: true,
        infoComponent: allVisibleColumn.length <= MAX_FREEZE_COUNT && InfoComponent
      })
    }

    if (viewSelector) {
      lists.push({
        label: 'Row density',
        value: 'table_view',
        icon: 'RowDensity',
        activeIcon: 'RowDensity',
        className: 'view-selector',
        list: dropDownList
      })
    }

    return lists
  }

  const getListItem = (columns, isLock = false) => {
    let list = []
    columns.forEach((column) => {
      if (column.addToColumnSelector) {
        const action = () => {
          setTimeout(() => {
            onChangeColumnSelector(allColumns)
          })
        }
        list.push({
          label: (
            <Selector
              column={column}
              isLock={isLock}
              allVisibleColumn={allVisibleColumn}
              canFreezeColumn={canFreezeColumn}
              freezedUnfreezeColumn={freezedUnfreezeColumn}
            />
          ),
          action,
          id: column.id,
          canDragDrop: column.canDragDrop,
          isDropDisabled: hasFreezedColumn && !column.isVisible
        })
      }
    })
    return list
  }

  let list = getListItem(allColumns) || []

  const getDropdownList = () => {
    let [freezed = [], unfreezed = []] = listData
    let unfreezedColumn = []
    let freezedColumn = []
    if (freezed?.length > 0) {
      freezedColumn = getListItem(compareColumn(allColumns, freezed), true)
    }
    if (unfreezed.length > 0) {
      unfreezedColumn = getListItem(compareColumn(allColumns, unfreezed), false)
    }
    return [freezedColumn, unfreezedColumn]
  }

  const onDragEnd = (result, draggableId) => {
    const { source, destination } = result
    if (!destination) {
      return
    }
    if (canFreezeColumn) {
      const sInd = source.droppableId
      const dInd = destination.droppableId
      if (sInd === dInd) {
        const items = reorderList(listData[sInd], source.index, destination.index)
        const newState = [...listData]
        newState[sInd] = items
        setDragListData(newState, 'setColumnFreeze')
      } else {
        const items = move(listData[sInd], listData[dInd], source, destination)
        const newState = [...listData]
        newState[sInd] = items[sInd]
        newState[dInd] = items[dInd]
        freezedUnfreezeColumn({ id: result.draggableId })
      }
    } else {
      const updatedList: any = reorderList(list, result.source.index, result.destination.index)
      const updatedOrderedColumnIds = updatedList.map((list) => list.id)
      setTableColumnOrder(updatedOrderedColumnIds)
    }
  }

  const primaryDropdownList = getSettingsDropdownList(viewSelector, columnSelector, canFreezeColumn)

  if (v2Features.advanceSearch) {
    return (
      <div className="NewSearch-Panel flex-column">
        <div className="flex-v-center flex-justify">
          <div className="flex-v-center">
            {v2Features.InlineSearch && (
              <div>
                {typeof v2Features.InlineSearch === 'function' ? <v2Features.InlineSearch /> : v2Features.InlineSearch}
              </div>
            )}
            {v2Features.AdvanceSearchComponent && (
              <div className="ml-10">
                {typeof v2Features.AdvanceSearchComponent === 'function' ? (
                  <v2Features.AdvanceSearchComponent />
                ) : (
                  v2Features.AdvanceSearchComponent
                )}
              </div>
            )}
          </div>
          <div className="TablePanel flex-v-center">
            <div className="TablePanel__actions ml-20">
              <div
                className={
                  'TablePanel__actions__items ' +
                  ((viewSelector && !columnSelector) || (!viewSelector && columnSelector)
                    ? 'TablePanel__actions__items--single'
                    : '')
                }>
                {v2Features.onSaveAsView && (
                  <>
                    {typeof v2Features.onSaveAsView === 'function' ? (
                      <v2Features.onSaveAsView />
                    ) : (
                      v2Features.onSaveAsView
                    )}
                  </>
                )}

                {v2Features.importEntries && (
                  <>
                    {typeof v2Features.importEntries === 'function' ? (
                      <v2Features.importEntries />
                    ) : (
                      v2Features.importEntries
                    )}
                  </>
                )}

                {v2Features.exportEntries && (
                  <>
                    {typeof v2Features.exportEntries === 'function' ? (
                      <v2Features.exportEntries />
                    ) : (
                      v2Features.exportEntries
                    )}
                  </>
                )}

                {canRefresh && (
                  <Button
                    className="mr-10 refresh-wrapper"
                    aria-label="Refresh List"
                    onClick={onRefresh}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onRefresh()
                      }
                    }}
                    testId="cs-table-refresh-icon"
                    size="regular"
                    buttonType="tertiary"
                    onlyIcon={true}
                    icon={'v2-Refresh'}
                    version="v2"
                    onlyIconHoverColor="secondary"
                    iconProps={{
                      withTooltip: true,
                      tooltipContent: 'Refresh',
                      tooltipPosition: 'left'
                    }}
                  />
                )}
                {withExportCta && withExportCta.component && withExportCta.showExportCta ? (
                  withExportCta?.asButtonIcon ? (
                    <>{withExportCta.component}</>
                  ) : (
                    <div className={`import-cta mr-20 ml-10`}>{withExportCta.component}</div>
                  )
                ) : null}
                <div>
                  {v2Features.canAssetViewToggle ? <v2Features.AssetViewToogle /> : null}
                </div>
                <TableSetting
                  isDisabled={totalCounts === 0}
                  setIsOpenAddColumn={setIsOpenAddColumn}
                  isOpenAddColumn={isOpenAddColumn}
                  primaryDropdownList={primaryDropdownList}
                />
              </div>
            </div>
          </div>
        </div>
        {v2Features.QueryPillsComponent && (
          <>
            {typeof v2Features.QueryPillsComponent === 'function' ? (
              <v2Features.QueryPillsComponent />
            ) : (
              v2Features.QueryPillsComponent
            )}
          </>
        )}
      </div>
    )
  }

  return (
    <div className="TablePanel flex-v-center">
      {canSearch && (
        <Search
          width="full"
          corners="regular"
          placeholder={searchPlaceholder}
          onChange={onChangeSearch}
          debounceSearch={true}
          value={ searchValue }
        />
      )}
      <div className={`flex-v-center ${canSearch ? '' : 'w-100 flex-justify'}`}>
        <label
          className="TablePanel__list-count flex-v-center"
          data-test-id={`${props.testId || 'cs-table'}-list-count`}>
          {showTotalCount && (
            <div>
              {loading ? (
                <CircularLoaderV2 size="small" />
              ) : (
                totalString
              )}
            </div>
          )}
          {canRefresh && (
            <Button
              className="ml-10 refresh-wrapper"
              aria-label="Refresh List"
              onClick={onRefresh}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onRefresh()
                }
              }}
              testId="cs-table-refresh-icon"
              size="regular"
              buttonType="tertiary"
              onlyIcon={true}
              icon={'v2-Refresh'}
              version="v2"
              onlyIconHoverColor="secondary"
              iconProps={{
                withTooltip: true,
                tooltipContent: 'Refresh',
                tooltipPosition: 'left'
              }}
            />
          )}
        </label>
        {columnSelector || viewSelector || (withExportCta && withExportCta.showExportCta) ? (
          <div className="TablePanel__actions ml-10">
            <div
              data-test-id={'table-panel-action-items'}
              className={
                'TablePanel__actions__items ' +
                ((viewSelector && !columnSelector) || (!viewSelector && columnSelector)
                  ? 'TablePanel__actions__items--single'
                  : '')
              }>
              {withExportCta && withExportCta.component && withExportCta.showExportCta ? (
                withExportCta?.asButtonIcon ? (
                  <>{withExportCta.component}</>
                ) : (
                  <div className={`import-cta mr-20 ml-10`}>{withExportCta.component}</div>
                )
              ) : null}

              <TableSetting
                isDisabled={totalCounts === 0}
                setIsOpenAddColumn={setIsOpenAddColumn}
                isOpenAddColumn={isOpenAddColumn}
                primaryDropdownList={primaryDropdownList}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default TablePanel
